// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.information_loginForm__mBaGB {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.information_button__0JyGR {
  margin-top: 8px;
  color: #090909;
  padding: 0.7em 1.7em;
  border-radius: 0.5em;
  cursor: pointer;
  height: -moz-fit-content;
  height: fit-content;
  border: 1px solid #e8e8e8;
  transition: all 0.3s;
  width: 100%;
}

.information_informationContainer__1aXq8 {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  justify-content: center;
  align-items: center;
  padding: 36px;
}

.information_select__zzWM3 {
  width: 550px;
}

.information_container__wTVhE {
  width: 80%;
  margin: auto;
  font-family: Arial, sans-serif;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 16px;
}

h2 {
  border-bottom: 2px solid #ddd;
  padding-bottom: 5px;
}

.information_demography__gleni,
.information_lastClinicalIntake__3Fay7,
.information_appointmentHistory__ZclH3,
.information_messageHistory__TgSiZ {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

p {
  margin: 5px 0;
}

hr {
  border: 0;
  border-top: 1px solid #eee;
  margin: 10px 0;
}

.information_appointmentHistory__ZclH3 div,
.information_messageHistory__TgSiZ div {
  margin-bottom: 10px;
}

.information_messageHistory__TgSiZ {
  display: flex;
  flex-direction: column;
}

.information_message__VzD0a {
  display: flex;
  flex-direction: column;
  max-width: 70%;
}

.information_message__VzD0a.information_user__lbbP5 {
  align-self: flex-end;
  align-items: flex-end;
}

.information_message__VzD0a.information_copilot__7DobZ {
  align-self: flex-start;
  align-items: flex-start;
}

.information_messageDate__W33nd {
  font-size: 0.8rem;
  color: #888;
}

.information_messageUser__LGxUC {
  font-weight: bold;
}

.information_messageBubble__B1GmK {
  background: #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.information_message__VzD0a.information_user__lbbP5 .information_messageBubble__B1GmK {
  background: #007bff;
  color: white;
}

.information_spinner__N4r72 {
  margin-top: 8px;
}

@media screen and (max-width: 760px) {
  .information_select__zzWM3 {
    width: 350px;
  }

  .information_container__wTVhE {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .information_demography__gleni,
  .information_lastClinicalIntake__3Fay7,
  .information_appointmentHistory__ZclH3,
  .information_messageHistory__TgSiZ {
    width: 100%;
  }

  .information_message__VzD0a {
    max-width: 90%;
  }
}

@media screen and (max-width: 500px) {
  .information_informationContainer__1aXq8 {
    padding: 16px;
  }

  .information_message__VzD0a {
    max-width: 100%;
  }
}

@media screen and (max-width: 420px) {
  .information_select__zzWM3 {
    width: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/information/information.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,wBAAmB;EAAnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;;;IAIE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".loginForm {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n\n.button {\n  margin-top: 8px;\n  color: #090909;\n  padding: 0.7em 1.7em;\n  border-radius: 0.5em;\n  cursor: pointer;\n  height: fit-content;\n  border: 1px solid #e8e8e8;\n  transition: all 0.3s;\n  width: 100%;\n}\n\n.informationContainer {\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  justify-content: center;\n  align-items: center;\n  padding: 36px;\n}\n\n.select {\n  width: 550px;\n}\n\n.container {\n  width: 80%;\n  margin: auto;\n  font-family: Arial, sans-serif;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-top: 16px;\n}\n\nh2 {\n  border-bottom: 2px solid #ddd;\n  padding-bottom: 5px;\n}\n\n.demography,\n.lastClinicalIntake,\n.appointmentHistory,\n.messageHistory {\n  background: #f9f9f9;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\np {\n  margin: 5px 0;\n}\n\nhr {\n  border: 0;\n  border-top: 1px solid #eee;\n  margin: 10px 0;\n}\n\n.appointmentHistory div,\n.messageHistory div {\n  margin-bottom: 10px;\n}\n\n.messageHistory {\n  display: flex;\n  flex-direction: column;\n}\n\n.message {\n  display: flex;\n  flex-direction: column;\n  max-width: 70%;\n}\n\n.message.user {\n  align-self: flex-end;\n  align-items: flex-end;\n}\n\n.message.copilot {\n  align-self: flex-start;\n  align-items: flex-start;\n}\n\n.messageDate {\n  font-size: 0.8rem;\n  color: #888;\n}\n\n.messageUser {\n  font-weight: bold;\n}\n\n.messageBubble {\n  background: #e0e0e0;\n  border-radius: 8px;\n  padding: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.message.user .messageBubble {\n  background: #007bff;\n  color: white;\n}\n\n.spinner {\n  margin-top: 8px;\n}\n\n@media screen and (max-width: 760px) {\n  .select {\n    width: 350px;\n  }\n\n  .container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .demography,\n  .lastClinicalIntake,\n  .appointmentHistory,\n  .messageHistory {\n    width: 100%;\n  }\n\n  .message {\n    max-width: 90%;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .informationContainer {\n    padding: 16px;\n  }\n\n  .message {\n    max-width: 100%;\n  }\n}\n\n@media screen and (max-width: 420px) {\n  .select {\n    width: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginForm": `information_loginForm__mBaGB`,
	"button": `information_button__0JyGR`,
	"informationContainer": `information_informationContainer__1aXq8`,
	"select": `information_select__zzWM3`,
	"container": `information_container__wTVhE`,
	"demography": `information_demography__gleni`,
	"lastClinicalIntake": `information_lastClinicalIntake__3Fay7`,
	"appointmentHistory": `information_appointmentHistory__ZclH3`,
	"messageHistory": `information_messageHistory__TgSiZ`,
	"message": `information_message__VzD0a`,
	"user": `information_user__lbbP5`,
	"copilot": `information_copilot__7DobZ`,
	"messageDate": `information_messageDate__W33nd`,
	"messageUser": `information_messageUser__LGxUC`,
	"messageBubble": `information_messageBubble__B1GmK`,
	"spinner": `information_spinner__N4r72`
};
export default ___CSS_LOADER_EXPORT___;
